module.exports = __webpack_public_path__ + "static/4-8be0fa9dbbbe85b73e55a16a9e144972.jpg";